__webpack_require__.p = "/views-board/referrals-hub/";